/**
 * Fixed logical rail size (CSS px). The pan clamps at this edge, so it must outlast
 * the longest playback: at 12ms per px this holds about 3.5 hours.
 */
export const TIMELINE_WORLD_WIDTH_PX = 1_048_576;
export const TIMELINE_WORLD_HEIGHT_PX = 2_400;

const MAX_ZOOM = 4;

/**
 * Floor so view math stays finite. Zoom can go far enough to see the whole
 * chapter with space around it.
 */
export const TIMELINE_MIN_ZOOM = 0.002;

/** Pixels of the world that stay on screen so a pan cannot lose the chapter. */
const WORLD_EDGE_SLIVER_PX = 64;

export function timelineMinZoom(): number {
  return TIMELINE_MIN_ZOOM;
}

export function timelineMaxZoom(): number {
  return MAX_ZOOM;
}

export function clampTimelineZoom(value: number): number {
  return Math.min(MAX_ZOOM, Math.max(timelineMinZoom(), value));
}

export function clampPanToWorld(
  panX: number,
  panY: number,
  zoom: number,
  stageW: number,
  stageH: number,
): { panX: number; panY: number } {
  const x = panAxisRange(stageW, TIMELINE_WORLD_WIDTH_PX * zoom);
  const y = panAxisRange(stageH, TIMELINE_WORLD_HEIGHT_PX * zoom);
  return {
    panX: Math.min(x.max, Math.max(x.min, panX)),
    panY: Math.min(y.max, Math.max(y.min, panY)),
  };
}

function panAxisRange(
  stage: number,
  worldScreen: number,
): { min: number; max: number } {
  const sliver = Math.min(WORLD_EDGE_SLIVER_PX, stage / 2);
  const min = sliver - worldScreen;
  const max = stage - sliver;
  if (min <= max) {
    return { min, max };
  }
  const center = (stage - worldScreen) / 2;
  return { min: center, max: center };
}
